// // Tabs.js
// import React, { useState } from 'react';
// import './Tabs.css'; 

// function Tabs({ onTabChange }) {
//   const [activeTab, setActiveTab] = useState('Tab1');

//   const handleTabClick = (tabName) => {
//     setActiveTab(tabName);
//     if (onTabChange) {
//       onTabChange(tabName); 
//     }
//   };


//   return (
//       <div className="Tabs-nav">
//         <button className={`tab-button ${activeTab === 'Tab1' ? 'active' : ''}`}
//         onClick={() => handleTabClick('Tab1')}>Home</button>
//         <button className={`tab-button ${activeTab === 'Tab2' ? 'active' : ''}`}
//         onClick={() => handleTabClick('Tab2')}>Products</button>
//         <button className={`tab-button ${activeTab === 'Tab3' ? 'active' : ''}`}
//         onClick={() => handleTabClick('Tab3')}>Traded-in/Demo Items</button>
//         <button className={`tab-button ${activeTab === 'Tab4' ? 'active' : ''}`}
//         onClick={() => handleTabClick('Tab4')}>Contact Us</button>
//       </div>
//   );
// }

// export default Tabs;


// Tabs.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Tabs.css';

function Tabs() {
  const location = useLocation();

  return (
    <div className="Tabs-nav">
      <Link to="/" className={`tab-button ${location.pathname === '/' ? 'active' : ''}`}>
        Home
      </Link>
      <Link to="/products" className={`tab-button ${location.pathname === '/products' ? 'active' : ''}`}>
        Products
      </Link>
      <Link to="/used-items" className={`tab-button ${location.pathname === '/used-items' ? 'active' : ''}`}>
        Traded-in/Demo Items
      </Link>
      <Link to="/contact-us" className={`tab-button ${location.pathname === '/contact-us' ? 'active' : ''}`}>
        Contact Us
      </Link>
    </div>
  );
}

export default Tabs;
